import { keyframes } from '@emotion/react';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

const ButtonStyles = ({ theme, removing }) => ({
  flexGrow: 1,
  width: '100%',
  height: '36px',
  padding: '0 12px!important',
  // Disable mouse events
  pointerEvents: removing ? 'none' : 'auto',
  cursor: removing ? 'not-allowed' : 'pointer',
  [theme.breakpoints.up('sm')]: {
    height: '40px',
    padding: '0 20px!important'
  },
  '&.Mui-disabled.MuiButton-outlined': {
    color: theme.palette.text.tertiary,
    borderColor: theme.palette.border.main,
    backgroundColor: theme.palette.background.grey.main
  },
  '&.Mui-disabled.MuiButton-primary': {
    color: theme.palette.text.primary,
    borderColor: 'none'
  },

  outline: 'none!important'
});

const iconAnimation = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const IconWrapperStyles = ({ theme }) => ({
  animation: `${iconAnimation} 1.5s ease-in-out`,
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '50%',
  height: '20px',
  width: '20px',
  [theme.breakpoints.up('md')]: {
    height: '24px',
    width: '24px'
  }
});

export const ButtonStyled = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'removing'
})(ButtonStyles);

export const IconWrapperStyled = styled(Box)(IconWrapperStyles);
